import axios from "axios";

const getCombustibles = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const idCaja = localStorage.getItem("idCaja");

  const userData = {
    nic: formattedNic,
    token: token,
    idCaja: +idCaja,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Articulos/GetArticulosCombustible`, userData);
  return response.data;
};

const combustibles = {
  getCombustibles,
};

export default combustibles;
